import styled from "styled-components";
import {Flex} from "./flex";

export const FlexAlignCenter = styled(Flex)`
    align-items: center;
`;
